function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 277.333h341.333V320H0zm0-128h341.333V192H0zm0-128h341.333V64H0z"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.333 341.333"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNDEuMzMzIiBoZWlnaHQ9IjM0MS4zMzMiIHZpZXdCb3g9IjAgMCAzNDEuMzMzIDM0MS4zMzMiPgogIDxwYXRoIGQ9Ik0wIDI3Ny4zMzNoMzQxLjMzM3Y0Mi42NjdoLTM0MS4zMzN6TTAgMTQ5LjMzM2gzNDEuMzMzdjQyLjY2N2gtMzQxLjMzM3pNMCAyMS4zMzNoMzQxLjMzM3Y0Mi42NjdoLTM0MS4zMzN6Ii8+Cjwvc3ZnPgo=";
export { SvgMenu as ReactComponent };